import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/site';

const HERO_IMAGE = 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20breaking%20news%20scene%20with%20red%20glowing%20headlines%20floating%20in%20dark%20void%2C%20shattered%20glass%20fragments%20with%20news%20text%20fragments%2C%20cinematic%20atmosphere%20with%20deep%20crimson%20and%20black%20tones%2C%20abstract%20editorial%20photography%20with%20intense%20mood%20lighting%2C%20mysterious%20journalism%20concept%20art%20with%20fog%20and%20light%20rays%20piercing%20through%20darkness&width=1600&height=600&seq=hero-bg-2026&orientation=landscape';

export default function HeroSection() {
  const heroArticles = hotArticles.filter(a => a.isHot).slice(0, 3);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={HERO_IMAGE}
        alt="黑料爆料"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-6">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-xs font-semibold mb-5 whitespace-nowrap">
              <i className="ri-flashlight-line"></i>
              实时追踪 · 最新爆料
            </div>
            <h1 className="font-heading text-2xl md:text-5xl font-black text-white leading-tight mb-4">
              全网热门黑料爆料
              <br />
              <span className="text-primary-300">一网打尽，速来吃瓜</span>
            </h1>
            <p className="text-white/70 text-sm md:text-base max-w-xl mb-8 leading-relaxed">
              覆盖51吃瓜黑料爆料、17c吃瓜黑料爆料，网红塌房现场、明星聊天记录泄露、博主反差视频，黑料爆料网官网入口直达
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/meiri-dasai"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors"
              >
                进入每日大赛
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="#subscribe"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white font-semibold text-sm hover:bg-white/10 transition-colors"
              >
                订阅最新爆料
                <i className="ri-notification-3-line"></i>
              </a>
            </div>
          </div>

          <div className="hidden lg:flex gap-4 mt-10">
            {heroArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="flex-1 group relative overflow-hidden rounded-lg h-24 bg-black/30 backdrop-blur-sm border border-white/10 hover:border-white/30 transition-all"
              >
                <div className="absolute inset-0 flex items-center px-4">
                  <div className="flex items-center gap-3 w-full">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white text-xs font-bold flex-shrink-0">
                      {article.isNew ? '新' : '热'}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-white text-sm font-medium truncate">{article.title}</p>
                      <p className="text-white/50 text-xs mt-0.5">
                        <span>{article.views.toLocaleString()} 阅读</span>
                        <span className="mx-2">·</span>
                        <span>{article.comments.toLocaleString()} 评论</span>
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}